import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Calendar, Award } from 'lucide-react';
export function HomeGetStarted() {
  return <section className="py-24 bg-off-white border-t border-subtle-gray" data-id="element-1674">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1675">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1676">
          <span className="inline-block bg-storm-red text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide mb-6" data-id="element-1677">
            How It Works
          </span>
          <h2 className="text-4xl md:text-5xl text-ink mb-4" data-id="element-1678">
            3 Steps to Get Started at Storm
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1679">
            A simple path from your first call to becoming a confident Storm
            student.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-1680">
          {[{
          step: '01',
          icon: Phone,
          title: 'Call Us',
          description: 'Call 517-220-0621 or send us a message and we will help you pick the right class or program for your child, yourself, or your family.'
        }, {
          step: '02',
          icon: Calendar,
          title: 'Try It Today',
          description: 'Come in for a trial class. Meet the coaches, see the floor, and let Storm show you what training looks like before you commit.'
        }, {
          step: '03',
          icon: Award,
          title: 'Stay and Thrive',
          description: 'Join the right program and watch students build confidence, focus, fitness, and real taekwondo skills over time.'
        }].map(({
          step,
          icon: Icon,
          title,
          description
        }) => <div key={step} className="relative bg-paper border border-subtle-gray rounded-2xl p-7 flex flex-col shadow-soft hover:shadow-md hover:border-storm-red/40 transition-all" data-id="element-1681">
              <span aria-hidden="true" className="absolute top-4 right-5 font-display text-5xl text-subtle-gray tracking-tight leading-none" data-id="element-1682">
                {step}
              </span>
              <div className="w-12 h-12 bg-storm-red/10 text-storm-red rounded-xl flex items-center justify-center mb-5" data-id="element-1683">
                <Icon className="w-6 h-6" data-id="element-1684" />
              </div>
              <h3 className="text-2xl text-ink mb-3 leading-tight" data-id="element-1685">{title}</h3>
              <p className="text-gray-warm leading-relaxed" data-id="element-1686">{description}</p>
            </div>)}
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1687">
          <Link to="/SignMeUp" className="btn-primary" data-id="element-1688">
            Start With a Trial Class
          </Link>
          <a href="tel:517-220-0621" className="btn-secondary" data-id="element-1689">
            <Phone className="w-5 h-5 mr-2" data-id="element-1690" />
            Call 517-220-0621
          </a>
        </div>
      </div>
    </section>;
}